'use client';

import { FC } from 'react';

import { AssetUtils } from '@ravago/shared/next-data-access';
import { ElementProps } from '@ravago/shared/page-data/models/base';
import { NormalizedProducer } from '@ravago/shared/page-data/models/contentful-mapped';
import { ProducerHeaderNode } from '@ravago/shared/page-data/models/elements';

import { AvatarNameHeader } from '../../shared/avatar-name-header/avatar-name-header';

export const ProducerHeaderElement: FC<ElementProps<ProducerHeaderNode>> = ({ node, globals }) => {
   const producer = globals.contentEntity as NormalizedProducer | undefined;

   return (
      <AvatarNameHeader
         theme={node.theme === 'primary' ? 'primary' : 'inverse-strong'}
         avatar={producer?.logo?.url ? AssetUtils.optimizeImageIfRequired(producer.logo.url, globals.acceptWebp) : undefined}
         name={producer?.name}
      />
   );
};
